export default function () {
    return {
        KEYS: {
            USER_NOT_UNIQUE_NAME: 'USER_NOT_UNIQUE_NAME'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/user/customError/index.js